// import React, { useEffect, useState } from 'react';
// import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
// import { verify_token } from './api/auth_api';
// import Donors from './components/Donors';
// import AddDonor from './components/AddDonor';
// import UpdateDonor from './components/UpdateDonor';
// import DonorDetails from './components/DonorDetails';
// import Beneficiaries from './components/Beneficiaries';
// import Login from './components/Login';
// import AddBeneficiary from './components/AddBeneficiary';
// import BeneficiaryDetails from './components/BeneficiaryDetails';
// import UpdateBeneficiary from './components/UpdateBeneficiary';
// import AddProvider from './components/AddProvider';
// import AddTransaction from './components/AddTransaction';
// import UpdateTransaction from './components/UpdateTransaction';
// import ForgotPassword from './components/ForgotPassword';
// import ChangePassword from './components/ChangePassword';
// import Budget from './components/Budget';
// import DigitalForm from './components/DigitalForm';
// import RequestManagement from './components/RequestManagement';
// import SendForm from './components/SendForm';
// import AddDonation from './components/AddDonation';
// import UpdateDonations from './components/UpdateDonations';
// import MainScreen from './components/MainScreen';
// import DigitalFormView from './components/DigitalFormView';
// import DocumentsImportant from './components/DocumentsImportant';

// // רכיב שמנהל את ההרשאות והכניסה האוטומטית
// const AuthManager = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isReady, setIsReady] = useState(false);

//   useEffect(() => {
//     const validate = async () => {
//       const token = localStorage.getItem('authToken');
//       const isRemembered = localStorage.getItem('rememberMe') === 'true';
//       const publicPaths = ['/login', '/forgot_password'];

//       // כניסה אוטומטית בדף לוגין
//       if (location.pathname === '/login' && token && isRemembered) {
//         try {
//           await verify_token();
//           navigate('/main_screen');
//           return;
//         } catch (e) {
//           localStorage.removeItem('authToken');
//         }
//       }

//       // הגנה על דפים פנימיים
//       if (!publicPaths.includes(location.pathname)) {
//         if (!token) {
//           navigate('/login');
//         } else {
//           try {
//             await verify_token();
//           } catch (err) {
//             localStorage.removeItem('authToken');
//             localStorage.removeItem('rememberMe');
//             navigate('/login');
//           }
//         }
//       }
//       setIsReady(true);
//     };

//     validate();
//   }, [location.pathname, navigate]);

//   if (!isReady && !['/login', '/forgot_password'].includes(location.pathname)) {
//     return <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px', fontSize: '20px', color: '#7879F1' }}>טוען...</div>;
//   }

//   return children;
// };

// const AppRouter = () => {
//   return (
//     <AuthManager>
//       <Routes>
//         <Route path="/donors/:donorId/donations/update/:donationId" element={<UpdateDonations />} />
//         <Route path="/donors/:donor_id" element={<DonorDetails />} />
//         <Route path="/donors/:donor_id/update" element={<UpdateDonor />} />
//         <Route path="/donors" element={<Donors />} />
//         <Route path="/add_donor" element={<AddDonor />} />
//         <Route path="/donors/:donor_id/donations/add" element={<AddDonation />} />

//         <Route path="/" element={<Login />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/forgot_password" element={<ForgotPassword />} />
//         <Route path="/change_password" element={<ChangePassword />} />
//         <Route path='/main_screen' element={<MainScreen />} />
//         <Route path="/DocumentsImportant" element={<DocumentsImportant />} />
//         <Route path="/beneficiaries" element={<Beneficiaries />} />
//         <Route path="/beneficiaries/:beneficiary_id" element={<BeneficiaryDetails />} />
//         <Route path="/beneficiaries/:beneficiary_id/update_beneficiary" element={<UpdateBeneficiary />} />
//         <Route path="/add_beneficiary" element={<AddBeneficiary />} />
//         <Route path="/beneficiaries/:beneficiary_id/add_transaction" element={<AddTransaction />} />
//         <Route path="/beneficiaries/:beneficiary_id/update_transaction/:transaction_id" element={<UpdateTransaction />} />
//         <Route path="/add_provider" element={<AddProvider />} />
//         <Route path="/budget" element={<Budget />} />
//         <Route path="/DigitalForm" element={<DigitalForm />} />
//         <Route path="/RequestManagement" element={<RequestManagement />} />
//         <Route path="/send_request" element={<SendForm />} />
//         <Route path="/digital-form/view/:id" element={<DigitalFormView />} />
//       </Routes>
//     </AuthManager>
//   );
// };

// export default AppRouter;






import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { verify_token } from './api/auth_api';
import Donors from './components/Donors';
import AddDonor from './components/AddDonor';
import UpdateDonor from './components/UpdateDonor';
import DonorDetails from './components/DonorDetails';
import Beneficiaries from './components/Beneficiaries';
import Login from './components/Login';
import AddBeneficiary from './components/AddBeneficiary';
import BeneficiaryDetails from './components/BeneficiaryDetails';
import UpdateBeneficiary from './components/UpdateBeneficiary';
import AddProvider from './components/AddProvider';
import AddTransaction from './components/AddTransaction';
import UpdateTransaction from './components/UpdateTransaction';
import ForgotPassword from './components/ForgotPassword';
import ChangePassword from './components/ChangePassword';
import Budget from './components/Budget';
import DigitalForm from './components/DigitalForm';
import RequestManagement from './components/RequestManagement';
import SendForm from './components/SendForm';
import AddDonation from './components/AddDonation';
import UpdateDonations from './components/UpdateDonations';
import MainScreen from './components/MainScreen';
import DigitalFormView from './components/DigitalFormView';
import DocumentsImportant from './components/DocumentsImportant';

// רכיב שמנהל את ההרשאות והכניסה האוטומטית
const AuthManager = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const validate = async () => {
      const token = localStorage.getItem('authToken');
      const isRemembered = localStorage.getItem('rememberMe') === 'true';
      const publicPaths = ['/login', '/forgot_password', '/DigitalForm'];

      // כניסה אוטומטית בדף לוגין
      if (location.pathname === '/login' && token && isRemembered) {
        try {
          await verify_token();
          navigate('/main_screen');
          return;
        } catch (e) {
          localStorage.removeItem('authToken');
        }
      }

      // הגנה על דפים פנימיים
      if (!publicPaths.includes(location.pathname)) {
        if (!token) {
          navigate('/login');
        } else {
          try {
            await verify_token();
          } catch (err) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('rememberMe');
            navigate('/login');
          }
        }
      }
      setIsReady(true);
    };

    validate();
  }, [location.pathname, navigate]);

  if (!isReady && !['/login', '/forgot_password', '/DigitalForm'].includes(location.pathname)) {
    return <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px', fontSize: '20px', color: '#7879F1' }}>טוען...</div>;
  }

  return children;
};

const AppRouter = () => {
  return (
    <AuthManager>
      <Routes>
        <Route path="/donors/:donorId/donations/update/:donationId" element={<UpdateDonations />} />
        <Route path="/donors/:donor_id" element={<DonorDetails />} />
        <Route path="/donors/:donor_id/update" element={<UpdateDonor />} />
        <Route path="/donors" element={<Donors />} />
        <Route path="/add_donor" element={<AddDonor />} />
        <Route path="/donors/:donor_id/donations/add" element={<AddDonation />} />

        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/change_password" element={<ChangePassword />} />
        <Route path='/main_screen' element={<MainScreen />} />
        <Route path="/DocumentsImportant" element={<DocumentsImportant />} />
        <Route path="/beneficiaries" element={<Beneficiaries />} />
        <Route path="/beneficiaries/:beneficiary_id" element={<BeneficiaryDetails />} />
        <Route path="/beneficiaries/:beneficiary_id/update_beneficiary" element={<UpdateBeneficiary />} />
        <Route path="/add_beneficiary" element={<AddBeneficiary />} />
        <Route path="/beneficiaries/:beneficiary_id/add_transaction" element={<AddTransaction />} />
        <Route path="/beneficiaries/:beneficiary_id/update_transaction/:transaction_id" element={<UpdateTransaction />} />
        <Route path="/add_provider" element={<AddProvider />} />
        <Route path="/budget" element={<Budget />} />
        <Route path="/DigitalForm" element={<DigitalForm />} />
        <Route path="/RequestManagement" element={<RequestManagement />} />
        <Route path="/send_request" element={<SendForm />} />
        <Route path="/digital-form/view/:id" element={<DigitalFormView />} />
      </Routes>
    </AuthManager>
  );
};

export default AppRouter;

